import { useState } from "react";
import signup from "skin/entry/query/signup";
import dict from 'skin/store/dict';
import useReferral from "skin/entry/hook/referral";
import useFormInput from "./input";

export default function usePartner() {
	const code = useReferral('ref_partner');
	const [wait, setWait] = useState(false);
	
	let { value, handlers, err, setErr } = useFormInput();

	const d = dict.list.find(e => e.value[0] === value.source)?.list?.[0] ?? '';

	return { d, wait, submit, value, handlers, err };

	function check() {
		let ok = true;
		if (!value.source) { ok = false; setErr.source('Выберите тип партнёрства'); }
		if (!value.login) { ok = false; setErr.login('Введите логин'); }
		if (!value.password) { ok = false; setErr.password('Введите пароль'); }
		if (!value.password2) { ok = false; setErr.password2('Повторите пароль'); }
		else if (value.password && value.password !== value.password2) { ok = false; setErr.password2('Пароли не совпадают'); }
		if (!value.phone) { ok = false; setErr.phone('Укажите и подтвердите номер телефона'); }
		return ok;
	}
	function submit() {
		const ok = check();
		if (!ok) return;
		setWait(true);
		signup({
			partner: true,
			login: value.login,
			password: value.password,
			password2: value.password2,
			phone: value.phone,
			tariff: value.source,
			ref: code
		})
			.catch(e => {
				alert('Ошибка при создании учётной записи: ' + e.toString())
				console.error('err', e);
			})
			.finally(() => setWait(false))
	}
}

